export const fetchRecommendedJobs = async () => {
  const page = 1;
  const pageSize = 5;
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/main/list/public-jobs?page=${page}&page_size=${pageSize}`,
      {
        method: "GET",
      }
    );
    if (!res.ok) {
      throw new Error("Something went wrong in fetching recommended jobs");
    }
    const data = await res.json();
    return data;
  } catch (err) {
    console.error("There was a problem with the fetch recommended", err);
    throw err;
  }
};
